var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":"li","active-class":"active","to":_vm.target,"exact":_vm.exact}},[_c('a',[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"link-text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-865a49ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/MenuItem.vue
// module id = null
// module chunks = 